module.exports = __webpack_public_path__ + "static/media/Liver failure.5ffa2cdd.webp";